/*
  survey-core 2.x changed several default property values. None of our ~511 stored survey
  definitions were written against those new defaults, so a definition that is silent about one
  of these properties renders differently under 2.x than it did under 1.9.116.

  Each entry below is a property whose 2.x default differs from 1.9.116, mapped to the 1.9.116
  value. Applied only when the definition does not set the property itself, so an author who
  chose a value still wins.

  Add to this list rather than injecting defaults at the call sites: the same omission has to be
  made on all eight rendering surfaces to be correct, and scattered copies drift.
*/
const V1_DEFAULTS = {
  // 2.x flipped "on" -> "off". Use "on", not "recursive": "recursive" renumbers questions
  // inside panels as "2.1.", "2.2.".
  showQuestionNumbers: 'on',
  // 2.x shrank the basic-header logo from 200px to 40px and dropped the fixed width.
  logoHeight: '200px',
  logoWidth: '300px',
  // 2.x flipped false -> true, which adds sd-root-modern--full-container (width/height 100%,
  // overflow auto, position relative) and an inner scroll wrapper. That reflows the survey
  // inside height-constrained parents such as the response drawer and the preview dialog.
  fitToContainer: false,
};

// Mutates and returns `content`, so it reads either as a statement or wrapped around an object
// literal. `=== undefined` rather than a falsy test: `fitToContainer: false` and
// `showQuestionNumbers: ''` are values an author can choose, and must survive.
export const applyV1Defaults = (content) => {
  Object.entries(V1_DEFAULTS).forEach(([property, value]) => {
    if (content[property] === undefined) content[property] = value;
  });
  return content;
};

export default V1_DEFAULTS;
